import React from 'react';

import { ICDCloseButton } from './interface';

import cdCloseBtn from 'img/cd-close-btn.svg';

import './styles.scss';

const CDCloseButton: React.FC<ICDCloseButton> = (props) => (
  <button className="close-button" {...props}>
    <img src={cdCloseBtn} alt="" />
  </button>
);

export default CDCloseButton;
